import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './carousel-fullwidth-item.component.scss';
var CarouselFullwidthItem = /** @class */ (function (_super) {
    tslib_1.__extends(CarouselFullwidthItem, _super);
    function CarouselFullwidthItem(element) {
        return _super.call(this, element) || this;
    }
    CarouselFullwidthItem.prototype.init = function () { };
    ;
    CarouselFullwidthItem.prototype.bindEvents = function () { };
    ;
    return CarouselFullwidthItem;
}(Base));
export { CarouselFullwidthItem };



//////////////////
// WEBPACK FOOTER
// ./components/carousel-fullwidth-item/carousel-fullwidth-item.component.ts
// module id = 193
// module chunks = 0